import { HttpClient } from '../../protocols/http/httpClient'
import { validateHttpStatus } from '../../../validation/validateHttpResponse'

export interface ResendSignatureEmail {
  execute: (signatureId: string) => Promise<any>
}

export class RemoteResendSignatureEmail implements ResendSignatureEmail {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  @validateHttpStatus
  async execute(signatureId: string): Promise<any> {
    const httpResponse = await this.httpPostClient.post?.({
      url: `${this.url}/contract-signatures/${signatureId}/resend-email`,
      data: {}
    })
    return httpResponse
  }
}
